import React, { useState } from "react";
import { TextField, Button, Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { validateAadhaar } from "../../helpers/commonHelper";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const DemographicAuth = ({ onSubmit, isLoading }) => {
  const [formData, setFormData] = useState({
    aadhaarNumber: "",
    dateOfBirth: "",
    gender: "",
    name: ""
  });

  const handleAadhaarChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 12) value = value.slice(0, 12);

    if (value.length > 8) {
      value = value.slice(0, 4) + "-" + value.slice(4, 8) + "-" + value.slice(8);
    } else if (value.length > 4) {
      value = value.slice(0, 4) + "-" + value.slice(4);
    }

    setFormData({ ...formData, aadhaarNumber: value });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const cleanAadhaar = formData?.aadhaarNumber.replace(/\D/g, "");
  const isAadhaarValid = cleanAadhaar.length === 12 && validateAadhaar(formData?.aadhaarNumber);

  const isValid = isAadhaarValid && formData?.dateOfBirth && formData?.gender && formData?.name.trim().length > 0;

  const handleSubmit = () => {
    if (isValid) {
      const [year, month, day] = formData?.dateOfBirth.split("-");
      const formattedDob = `${day}-${month}-${year}`;

      onSubmit({
        aadhaarNumber: cleanAadhaar,
        dateOfBirth: formattedDob,
        gender: formData?.gender,
        name: formData?.name.trim()
      });
    }
  };

  return (
    <div className="mt-3">
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <TextField
            label={
              <>
                Aadhaar Number <span className="txtRed">*</span>
              </>
            }
            variant="standard"
            fullWidth
            value={formData?.aadhaarNumber}
            onChange={handleAadhaarChange}
            placeholder="XXXX-XXXX-XXXX"
            inputProps={{ maxLength: 14, inputMode: "numeric" }}
            error={formData?.aadhaarNumber.length > 0 && !isAadhaarValid}
            helperText={
              formData?.aadhaarNumber.length > 0 && !isAadhaarValid
                ? "Enter a valid 12-digit Aadhaar number"
                : ""
            }
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <TextField
            label={
              <>
                Full Name <span className="txtRed">*</span>
              </>
            }
            variant="standard"
            fullWidth
            name="name"
            value={formData?.name}
            onChange={handleChange}
            placeholder="Enter your full name as per Aadhaar"
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <FormControl fullWidth variant="standard">
            <InputLabel id="gender-label">Gender <span className="txtRed">*</span></InputLabel>
            <Select
              labelId="gender-label"
              name="gender"
              value={formData?.gender}
              onChange={handleChange}
            >
              <MenuItem value="M">Male</MenuItem>
              <MenuItem value="F">Female</MenuItem>
              <MenuItem value="O">Other</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={
                <>
                  Date of Birth <span className="txtRed">*</span>
                </>
              }
              format="DD-MM-YYYY"
              value={formData?.dateOfBirth ? dayjs(formData?.dateOfBirth) : null}
              maxDate={dayjs()}
              onChange={(newValue) => {
                if (!newValue) {
                  setFormData({ ...formData, dateOfBirth: "" });
                  return;
                }
                const selectedDate = dayjs(newValue).format("YYYY-MM-DD");
                setFormData({ ...formData, dateOfBirth: selectedDate });
              }}
              slotProps={{
                textField: {
                  variant: "standard",
                  fullWidth: true,
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>

      <Button
        fullWidth
        variant="contained"
        sx={{
          marginTop: 4,
          background: "linear-gradient(90deg, #D063CA, #B056CC)",
          textTransform: "none",
          borderRadius: "25px",
          padding: "10px 0",
        }}
        onClick={handleSubmit}
        disabled={!isValid || isLoading}
      >
        Authenticate
      </Button>
    </div>
  );
};

export default DemographicAuth;
